export interface Discount {
    id: string;
    productDiscount?: boolean;
    isPercentage: boolean;
    label: string;
    value: number;
    invalid?: boolean;
}

export interface PriceBaseInterface {
    subTotalPrice: number;
    handlingPrice: number;
    totalPrice: number;
    discounts: Discount[];
}

export interface ProductPriceInterface {
    original: number;
    current: number;
    discount?: Discount;
    discountInPercentage?: number;
    discountInPrice?: number;
}

export enum Currency {
    eur = 'EUR',
}
